/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.30/esri/copyright.txt for details.
*/
function e(e,t){const n=t.loseContext&&e.getExtension("WEBGL_lose_context");return n?{loseRenderingContext:()=>n.loseContext()}:null}export{e as load};
